export default __webpack_public_path__ + "static/media/imagem-grid-2.60b3aa90.png";